import { useState, useEffect, useCallback } from 'react';
import axiosInstance from '../helpers/axios';
import { useSelector,useDispatch } from "react-redux";
import { userActions } from "../actions/user.actions";
import { appContextConstants } from '../constants/appContext.constants';
const FILTER_KEY = "TableFilters";
const getSavedFilters = () => {
  try {
    return JSON.parse(sessionStorage.getItem(FILTER_KEY) || "null") || {};
  } catch {
    return {};
  }
};
const useApplicationData = ({ status, user, dependencies = {} }) => {
  const productTypeSelected = useSelector((state) => state.ProductTypeFilter.selectedProductType);
  const dispatch = useDispatch();
// const productType = sessionStorage.getItem("sanctionProductType");
  const saved = getSavedFilters();
  const [tableData, setTableData] = useState([]);

  const [currentPage, setCurrentPage] = useState(
    sessionStorage.getItem("page") ? parseInt(sessionStorage.getItem("page")) : 1
  );
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalFetchRows, setTotalFetchRows] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [filterDateFrom, setFilterDateFrom] = useState(saved.filterDateFrom || null);
  const [filterDateTo, setFilterDateTo] = useState(saved.filterDateTo || null);
  const [instituteId, setInstituteId] = useState(saved.instituteId || null);
  const [instituteName, setInstituteName] = useState(saved.instituteName || '');
  const [selectedCRA, setSelectedCRA] = useState(saved.selectedCRA || '');
  const [activePage, setActivePage] = useState(15);
  useEffect(() => {
    sessionStorage.setItem(
      FILTER_KEY,
      JSON.stringify({
        filterDateFrom,
        filterDateTo,
        instituteId,
        instituteName,
        selectedCRA,
      })
    );
  }, [filterDateFrom, filterDateTo, instituteId, status,instituteName, selectedCRA]);
  const buildQueryParams = useCallback((overrides = {}) => {
    const params = {};
    if (filterDateFrom && filterDateTo) {
      params.fromDate = filterDateFrom;
      params.toDate = filterDateTo + " 23:59:59";
    }

    if (instituteId) {
      params.instituteId = instituteId;
    }

    if (status) {
      params.status = status;
    }

    if (selectedCRA) {
      params.cra = selectedCRA;
    }
    if (productTypeSelected && productTypeSelected !== "all") {
      params.productType = Number(productTypeSelected);
    }

    params.perPage = rowsPerPage;
    params.pageNo = currentPage;

    return { ...params, ...overrides };
  }, [filterDateFrom, filterDateTo, instituteId, status, selectedCRA, productTypeSelected, rowsPerPage, currentPage]);

  const fetchData = useCallback(async (queryOverrides = {}) => {
    setIsLoading(true);
    
    try {
      const queryParams = buildQueryParams(queryOverrides);
      const response = await axiosInstance.get('/admin/application', {
        params: queryParams,
        headers: {
        },
      });

      const data = response?.data?.data;
      
      setTableData(data?.applicantDetails || []);
      setCurrentPage(data?.pagination?.currentPage || 1);
      setTotalFetchRows(data?.pagination?.totalRows || 0);
      setRowsPerPage(data?.pagination?.perPage || 10);
      return data;
    } catch (error) {
      console.error('Error fetching application data:', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, [buildQueryParams, user, dispatch, productTypeSelected]);
  const handlePageChange = useCallback((pageNumber) => {
    setCurrentPage(pageNumber);
    fetchData({ pageNo: pageNumber });
  }, [fetchData]);

  const handleRowsPerPageChange = useCallback((number) => {
    setActivePage(number);
    setRowsPerPage(number);
    fetchData({ perPage: number, pageNo: 1 });
  }, [fetchData]);

  const handleSearch = useCallback(() => {
    fetchData({ pageNo: 1 });
  }, [fetchData]);

  const handleDateFilter = useCallback((startDate, endDate) => {
    setFilterDateFrom(startDate);
    setFilterDateTo(endDate);
  }, []);

  const clearFilters = useCallback(() => {
    sessionStorage.removeItem(FILTER_KEY);
    setFilterDateFrom(null);
    setFilterDateTo(null);
    setInstituteId(null);
    setInstituteName('');
    setSelectedCRA('');
    setCurrentPage(1);
    setActivePage(15);
    fetchData({
      fromDate: undefined,
      toDate: undefined,
      instituteId: undefined,
      cra: undefined,
      pageNo: 1
    });
  }, [fetchData]);

  const handleCRAChange = useCallback((craValue) => {
    setSelectedCRA(craValue);
    fetchData({ cra: craValue, pageNo: 1 });
  }, [fetchData]);

  useEffect(() => {
    const shouldFetch = 
      !dependencies.usersearchdefstate && 
      !dependencies.usersearchinsstate;

    if (shouldFetch) {
      dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: { status } });
      fetchData();
    } else {
      if (dependencies.usersearchdefstate) {
        setIsLoading(false);
        setTableData(dependencies.usersearchdefstate?.applicantDetails || []);
        setCurrentPage(dependencies.usersearchdefstate?.pagination?.currentPage || 1);
        setTotalFetchRows(dependencies.usersearchdefstate?.pagination?.totalRows || 0);
        setRowsPerPage(dependencies.usersearchdefstate?.pagination?.perPage || 10);
      }
      if (dependencies.usersearchinsstate) {
        setIsLoading(false);
        setTableData(dependencies.usersearchinsstate || []);
      }
    }
  }, [
    status,
    productTypeSelected,
    dependencies.insubstate,
    dependencies.datestate,
    dependencies.usersearchdefstate,
    dependencies.usersearchinsstate,
  ]);

  return {
    tableData,
    currentPage,
    rowsPerPage,
    totalFetchRows,
    isLoading,
    productTypeSelected,
    filterDateFrom,
    filterDateTo,
    instituteId,
    selectedCRA,
    activePage,

    setFilterDateFrom,
    setFilterDateTo,
    setInstituteId,
    setSelectedCRA,
    setCurrentPage,

    fetchData,
    handlePageChange,
    handleRowsPerPageChange,
    handleSearch,
    handleDateFilter,
    clearFilters,
    handleCRAChange,
    instituteName,
    setInstituteName,
  };
};

export default useApplicationData;